import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import moment from "moment";

const Date = styled.small`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #8a8d8f;

  &.title-lg {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
  }
`;

const Title = styled.div`
  color: #5e514d;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin: 4px 0 8px 0;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;

  &.title-lg {
    font-size: 24px;
    line-height: 36px;
  }
`;

const Subtitle = styled.div`
  color: #776e64;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin-bottom: 16px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  &.title-lg {
    font-weight: normal;
    -webkit-line-clamp: 2;
  }
`;

const ReadMore = styled.div`
  font-weight: bold;
  font-size: 0.8em;
  color: #f2a900;

  &:hover {
    cursor: pointer;
  }

  &.title-lg {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
  }
`;

const Container = styled.div`
  border-bottom: 1px solid #edeeee;

  &:hover {
    border-bottom: 1px solid #f2a900;
  }

  &:hover ${Title} {
    color: #f2a900;
    cursor: pointer;
  }
`;

const Article = (props) => {
  const { t } = useTranslation();

  // const toLink = () => {
  //   window.location.href = `/article-detail/${props.slug}`;
  // };
  const toLink = () => {
    if(props.type === "announcement"){
      window.location.href = `/article-detail/${props.slug}`;
    } else if(props.type === "pressconference"){  
      window.location.href = `/article-detail2/${props.slug}`;
    } else if(props.type === "newsroom"){
      window.location.href = `/article-detail3/${props.slug}`;
    } else if(props.type === "inspirasi"){
      window.location.href = `/inspiration/artikel/${props.slug}`;
    }
  };

  const date = moment(props.date, "DD-MM-YYYY HH:mm:ss").format("DD MMMM YYYY");

  return (
    <Container onClick={() => toLink()}>
      <Row>
        <Col>
          {typeof props.date != "undefined" && (
          <Date className={props.largeTitle ? "title-lg" : ""}>{date}</Date>
          )}

          {typeof props.creator != "undefined" && (
          <Date className={props.largeTitle ? "title-lg" : ""}>{props.creator}</Date>
          )}
        </Col>
        {props.readMore === "tr" ? (
          <Col className="text-end">
            <ReadMore className={props.largeTitle ? "title-lg" : ""}>
              {t("read_more")}
            </ReadMore>
          </Col>
        ) : (
          ""
        )}
      </Row>
      <Title className={props.largeTitle ? "title-lg" : ""}>
        {props.title}
      </Title>
      <Subtitle className={props.largeTitle ? "title-lg" : ""}>
        {props.subtitle}
      </Subtitle>
    </Container>
  );
};

export default Article;
